import React from 'react';

import moment from 'moment-timezone';

import { HorizontallyCenteringContainer } from './utils';
import { parseMemberData } from './utils';

export default function RebatePointsView({ memberData }) {
    const { currentCycleInfo, graceCyclesInfo, graceCycleInfo } = parseMemberData(memberData);

    // Combine extra grace cycles
    if (!!graceCycleInfo) {
        graceCyclesInfo.forEach((c, idx) => {
            if (idx === 0) {
                return;
            }
            graceCycleInfo.PointsBALValue = (graceCycleInfo?.PointsBALValue || 0) + (c?.PointsBALValue || 0);
        })
    }

    const pointsBAL = currentCycleInfo?.PointsBALValue || 0;
    const gracePointsBAL = graceCycleInfo?.PointsBALValue || 0;

    return (

        <>
            <HorizontallyCenteringContainer>
                <p className="app-text thin-line">
                    <span className="swensens-color bold">Current Rebate$: {pointsBAL.toFixed(2)}</span>
                </p>
            </HorizontallyCenteringContainer>
            {(!!currentCycleInfo && pointsBAL > 0) && (
                <>
                    <HorizontallyCenteringContainer>
                        <p className="app-text thin-line">
                            (expiring on {moment(new Date(currentCycleInfo.PointsExpiringDate)).format('DD MMM YYYY')})
                        </p>
                    </HorizontallyCenteringContainer>
                </>
            )}
            {gracePointsBAL > 0 && (
                <>
                    <HorizontallyCenteringContainer>
                        <p className="app-text thin-line">
                            <span className="swensens-color bold">Grace Rebate$: {gracePointsBAL.toFixed(2)}</span>
                        </p>
                    </HorizontallyCenteringContainer>
                    <HorizontallyCenteringContainer>
                        <p className="app-text thin-line">
                            (expiring on {moment(new Date(graceCycleInfo.PointsExpiringDate)).format('DD MMM YYYY')})
                        </p>
                    </HorizontallyCenteringContainer>
                </>
            )}
        </>
    );
}
